import React, { CSSProperties } from "react";
import { SpacingStyle } from "core/styles/paddingMarginStyle";
import {
  Container,
  InfoIcon,
  DangerIcon,
  LightIcon,
  Color,
  InfoBlackIcon,
} from "./_inlineBannerStyle";

type Icon = "light" | "info" | "danger" | "info-2";

const icon = (type?: Icon | null) => {
  switch (type) {
    case "light":
      return <LightIcon />;
    case "info":
      return <InfoIcon />;
    case "info-2":
      return <InfoBlackIcon />;
    case "danger":
      return <DangerIcon />;
    default:
      return null;
  }
};

export type InlineBannerProps = {
  children?: React.ReactNode;
  type?: Icon | null;
  color?: Color;
  bold?: boolean;
  "data-testid"?: string;
  size?: number;
  width?: string;
  gap?: number;
  style?: CSSProperties;
} & SpacingStyle;

function InlineBanner(props: InlineBannerProps) {
  const { type, children, "data-testid": dataTestId, ...rest } = props;

  return (
    <Container data-testid={dataTestId} {...rest}>
      {icon(type)}
      {children}
    </Container>
  );
}

InlineBanner.defaultProps = {
  children: null,
  type: "info",
  color: "default",
  bold: false,
};

export default InlineBanner;
